import { Checkbox } from "@/components/ui/checkbox";
import { WIDGETS } from "@/lib/widgets";

export function WidgetPicker({ value, onChange, prefix }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid={`${prefix}-widgets`}>
      {WIDGETS.map(([k, l]) => (
        <label key={k} className="flex cursor-pointer items-center gap-2.5 rounded-md border px-3 py-2 text-sm transition-colors hover:bg-muted">
          <Checkbox checked={value.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`${prefix}-widget-${k}`} />
          {l}
        </label>
      ))}
    </div>
  );
}
